<template>
    <div class="teaching-dynamics">
        <div class="teaching-dynamics-top">
            <div class="teaching-dynamics-top-item">
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '互动'"
                    :end-val="interact"
                    color="#FFFFFF"
                    countSize="24px"
                    :countWeight="700"
                    :isConvert="interact > 10000 ? 1 : -1"
                    style="height:100%;"
                >
                </count-up>
                <div class="name">互动</div>
            </div>
            <div class="teaching-dynamics-top-line"></div>
            <div class="teaching-dynamics-top-item">
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '考试'"
                    :end-val="exam"
                    color="#FFFFFF"
                    countSize="24px"
                    :countWeight="700"
                    :isConvert="exam > 10000 ? 1 : -1"
                    style="height:100%;"
                >
                </count-up>
                <div class="name">考试</div>
            </div>
            <div class="teaching-dynamics-top-line"></div>
            <div class="teaching-dynamics-top-item">
                
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '资源'"
                    :end-val="resource"
                    color="#FFFFFF"
                    countSize="24px"
                    :countWeight="700"
                    :isConvert="resource > 10000 ? 1 : -1"
                    style="height:100%;"
                >
                </count-up>
                <div class="name">资源</div>
            </div>
            <div class="teaching-dynamics-top-line"></div>
            <div class="teaching-dynamics-top-item">
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '题库'"
                    :end-val="question"
                    color="#FFFFFF"
                    countSize="24px"
                    :countWeight="700"
                    :isConvert="question > 10000 ? 1 : -1"
                    style="height:100%;"
                >
                </count-up>
                <div class="name">题库</div>
            </div>
            <div class="teaching-dynamics-top-line"></div>
            <div class="teaching-dynamics-top-item">
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="'code_' + '综合评审'"
                    :end-val="activity"
                    color="#FFFFFF"
                    countSize="24px"
                    :countWeight="700"
                    :isConvert="activity > 10000 ? 1 : -1"
                    style="height:100%;"
                >
                </count-up>
                <div class="name">综合评审</div>
            </div>
        </div>
        <div class="teaching-dynamics-content">
            <!-- @mouseover="hoverEvent" @mouseout="mouseleaveEvent" -->
            <div class="data-list" id="dynamic-ul"  ref="dynamicUl">
                <div class="data-box" v-for="(item,index) in dataList" :key="index">
                    <div class="data-box-item" v-for="sitem,sindex in item.list" :key="sindex" :style="sindex % 2 == 0 ? `margin-left:${sitem.left}px` : `margin-right:${sitem.left}px`">
                        <div class="title">
                            {{ getSourceByType(sitem.type) }}  {{ sitem.operationTime }}
                        </div>
                        <div class="info" :title="sitem.operation">
                            {{ sitem.operation }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img class="center-background" :src="require('@/assets/images/sydataboard/center-bg.png')" alt="">
        <img class="left-background" :src="require('@/assets/images/sydataboard/left-bg.png')" alt="">
        <img class="right-background" :src="require('@/assets/images/sydataboard/right-bg.png')" alt="">
    </div>
</template>
<script>
import {getTeachingDynamicAPI} from "@/service/api.js"
import CountUp from "@/components/countUp.vue";
export default {
  name: 'teaching-dynamics',
  components: {
    CountUp, //数据卡片
  },
  props:{
    //请求参数
    params: {
        type: Object,
        default: ()=>{}
    },
    interactNumber:{
        type:Number,
        default:0
    },
    examNumber:{
        type:Number,
        default:0
    },
    quesNumber:{
        type:Number,
        default:0
    },
    activityNumber:{
        type:Number,
        default:0
    },
    resTotal:{
        type:Number,
        default:0
    }
  },
  data() {
    return {
      dataList:[],
      scrollInterval: {
        minTop:0,
        maxTop:0
      },//动态滚动区间,
      scrollIngDynamicList: [],
      timer: null,
    }
  },
  watch:{
    params: {
        deep: true,
        handler (val) {
            this.getTeachingDynamic();
        }
    },
  },
  computed:{
    interact(){
        return this.interactNumber
    },
    exam(){
        return this.examNumber
    },
    resource(){
        return this.resTotal
    },
    question(){
        return this.quesNumber
    },
    activity(){
        return this.activityNumber
    }
  },
  methods: {
    /**
     * @name 获取来源
     */
    getSourceByType(type){
        let name = ''
        switch(type){
            case 1:
                name = '作业';
                break;
            case 2:
                name = '资源';
                break;
            case 3:
                name = '评价';
                break;
            case 4:
                name = '互动';
                break;
            case 6:
                name = '题库';
                break;
            case 7:
                name = '活动评审';
                break;
            case 8:
                name = '名师工作室';
                break;
            case 9:
                name = '集体备课';
                break;
            case 10:
                name = '听评课';
                break;
            case 11:
                name = '特色活动';
                break;
            case 12:
                name = '在线课程';
                break;
        }
        return name
    },

    /**
     * 鼠标悬停停止滚动
     */
    hoverEvent() {
        clearInterval(this.timer);
    },
    /**
     * 鼠标离开继续滚动
     */
    mouseleaveEvent() {
        this.timer = setInterval(this.dynamicScroll, 20);
    },
    /**
     * 动态滚动效果
     */
    dynamicScroll() {
        let _this = this;
        let arr = this.$refs.dynamicUl.children;
        this.scrollInterval.maxTop = this.$refs.dynamicUl.offsetHeight - this.$refs.dynamicUl.parentNode.offsetHeight
        for (var i = 0; i < arr.length; i++) {
            if (_this.scrollIngDynamicList.length != arr.length) {
                _this.scrollIngDynamicList[i] = arr[i].offsetTop;
            }
            arr[i].style.top = _this.scrollIngDynamicList[i] - 60 + "px";
            _this.scrollIngDynamicList[i]--;
            if (_this.scrollIngDynamicList[i] <= -_this.scrollInterval.maxTop) {
                _this.scrollIngDynamicList[i] = _this.scrollInterval.maxTop;
            }
        }
        // console.log(this.scrollIngDynamicList);
    },
    /**
     * @name 获取教学动态
     */
    getTeachingDynamic(){
        getTeachingDynamicAPI({...this.params}).then((res)=>{
            let dataList = []
            let i = 0
            let oldList = res.map((item,index)=>{
                if(index % 2 == 0 && index != 0){
                    if(i > 0){
                        i = 0
                    }else{
                        i = i + 1
                    }
                }
                let left = i * 30
                return {
                    ...item,
                    left: left
                }
            })
            for (let index = 0; index < oldList.length; index += 2) {
                dataList.push({
                    list:[oldList[index], oldList[index + 1]]
                });
            }
            this.dataList = dataList
        }).catch((err)=>{
            this.$Message.error('教学动态获取失败！');
        })
    }
  },
  mounted() {
    //获取教学动态
    this.getTeachingDynamic();
  }
}
</script>
<style lang="scss" scoped>
.teaching-dynamics{
    width: 100%;
    height: 430px;
    position: relative;
    margin-bottom: 10px;
    .teaching-dynamics-top{
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: calc(100% - 60px);
        margin: 0 auto;
        .teaching-dynamics-top-item{
            display: inline-flex;
            flex-direction: column;
            .number{
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
            }
        }
        .teaching-dynamics-top-line{
            background: linear-gradient(0deg, #0D1A47 0%, #1C5DBB 56.99999999999999%, #0D1A47 100%);
            width: 3px;
            height: 43px;
        }
    }
    .teaching-dynamics-content{
        width: calc(100% - 60px);
        height: calc(100% - 70px);
        position: relative;
        overflow: hidden;
        margin: 10px auto 0;
        .data-list{
            width: 100%;
            // height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 auto;
            // justify-content: center;
            position: relative;
            z-index: 2;
        }
        #dynamic-ul {
            &.data-box {
                cursor: pointer;
            }

            // height: 100%;
            animation: infinitevertical 50s linear infinite;

            &:hover {
                animation-play-state: paused;
            }

        }
        .data-box{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin-bottom: 45px;
            // margin: 20px 0;
            .data-box-item{
                display: inline-block;
                width: 250px;
                // padding: 0 10px;
                padding: 0 15px;
                color: #FFFFFF;
                text-align: left;
                position: relative;
                cursor: pointer;
                background: linear-gradient(-2deg, #2465CF 0%, transparent 60%);
                .title{
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-bottom: 5px;
                }
                .info{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FFFFFF;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                &:hover{
                    background: linear-gradient(0deg, #D88815 0%, #0C1947 100%);
                }
            }
        }
    }
    .center-background{
        height: calc(100% - 70px);
        width: auto;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 10px;
    }
    .left-background{
        width: auto;
        height: 100%;
        position: absolute;
        top: 0;
        left: -5px;
    }
    .right-background{
        width: auto;
        height: 100%;
        position: absolute;
        top: 0;
        right: -5px;
    }
}
/* 无限滚动垂直 */
@keyframes infinitevertical {
    0% {
        transform: translateY(0%);
    }

    100% {
        transform: translateY(-90%);
    }
}
</style>
<style lang="scss">
</style>